<template>
<div class="notification-dropdown">
    <span id="notification-drop" class="i-nav-notification"/>
    <vuestic-dropdown
      v-model="isShown"
      position="bottom"
      class="notification-dropdown__list"
    >
    <div>
      <br>
          <!-- <b>{{ alertas }} alertas de monitoramento</b> -->
          <ul v-if="notifications.length == 0" style="color: white;">Você não tem Notificacões</ul>
          <ul v-else v-for="notification in notifications" :key="notification.id" class="dropdown-item" style="display:block;">
           <strong>
             <span>{{ notification.data.titulo }}</span>
             <span v-if="notification.read_at == null"></span>
             <span v-else><i class="fa fa-check-circle" style="margin-left: 15px;" aria-hidden="true"></i></span>
           </strong>
            <br>
            <span @click="markAsRead(notification.id)" class="mt-2" style="color:white;">{{ notification.data.descricao }}</span>
          </ul>
          </div>
    </vuestic-dropdown>
</div>

</template>

<script>
import urlApi from '../../../../../router/urlApi'
import urlApiV2 from '../../../../../router/urlApiV2'

export default {
  name: 'notification-dropdown',
  data () {
    return {
      isShown: false,
      alertas: 0,
      notifications: '',
      upHere: false,
      id: ''
    }
  },
  props: {
    options: {
      type: Array,
      default: () => [
        {
          name: 'sentMessage',
          details: { name: 'Teste' },
        },
        {
          name: 'uploadedZip',
          details: { name: 'Oleg M', type: 'typography component' },
        },
        {
          name: 'startedTopic',
          details: { name: 'Andrei H' },
        },
      ],
    },
  },
  mounted () {
    let self = this
    this.$http.get(urlApi + '/aulas/alertas').then(function (response) {
      self.alertas = response.data.dados
      if(self.alertas > 0){document.getElementById('notification-drop').classList.add("notify");}
    }),

    this.$http.get(urlApiV2 + '/autoescola/notificacoes')
    .then((response) => {
      console.log(response.data);
      this.notifications = response.data
      if(self.notifications > 0){document.getElementById('notification-drop').classList.add("notify");}
    })
  },

  methods: {

    markAsRead(id) {
      let data = {
        id: id
      }
      this.$http.post(urlApiV2 + '/autoescola/notification-read', data)
      .then((response) => {
        console.log(response);
      })
       this.$http.get(urlApiV2 + '/autoescola/notificacoes')
       .then((response) => {
      console.log(response.data);
      this.notifications = response.data
    })
    },
  }
}
</script>


<style lang="scss">
@import '../../../../../vuestic-theme/vuestic-sass/resources/resources';

.notification-dropdown {
  @include flex-center();
  cursor: pointer;

  @at-root {
    .notification-dropdown__list {
      width: 270px;
      height: 100px;
      cursor: pointer;
    }
  }

  .i-nav-notification {
    position: absolute;
  }

  .notify {
    &::after {
      content: '';
      position: absolute;
      right: -4px;
      top: 0;
      background-color: $brand-primary;
      height: 12px;
      width: 12px;
      border-radius: 50%;
    }
  }

}
</style>
